import Events from "./Events/Events";
import YoutubeUpload from "./Youtube/YoutubeUpload";


const Comunicacion: React.FC = () => {
  return (<>
      <YoutubeUpload></YoutubeUpload>
      <Events></Events>
  </>
  );
};

export default Comunicacion;
